import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { AnimatePresence } from "framer-motion/dist/framer-motion";

import Petals from "./components/Petals";
import HeartTrail from "./components/HeartTrail";
import IntroAct from "./acts/IntroAct";
import CatchAct from "./acts/CatchAct";
import PuzzleAct from "./acts/PuzzleAct";
import MatchAct from "./acts/MatchAct";
import BossAct from "./acts/BossAct";
import JourneyAct from "./acts/JourneyAct";
import BouquetAct from "./acts/BouquetAct";
import ScratchAct from "./acts/ScratchAct";
import WallAct from "./acts/WallAct";
import FinaleAct from "./acts/FinaleAct";

import { GameProvider, useGame } from "./GameState";
import { ACTS } from "./MothersDayData";
import "./MothersDay.css";

const Inner = () => {
  const [actIdx, setActIdx] = useState(0);
  const [trailEnabled, setTrailEnabled] = useState(true);
  const { reset } = useGame();

  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) setTrailEnabled(false);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [actIdx]);

  const next = () => setActIdx((i) => Math.min(i + 1, ACTS.length - 1));
  const replay = () => { reset(); setActIdx(0); };
  const goTo = (i) => setActIdx(i);

  const currentAct = ACTS[actIdx].id;

  const renderAct = () => {
    switch (currentAct) {
      case "intro":   return <IntroAct key="intro" onNext={next} />;
      case "catch":   return <CatchAct key="catch" onNext={next} />;
      case "puzzle":  return <PuzzleAct key="puzzle" onNext={next} />;
      case "match":   return <MatchAct key="match" onNext={next} />;
      case "boss":    return <BossAct key="boss" onNext={next} />;
      case "journey": return <JourneyAct key="journey" onNext={next} />;
      case "bouquet": return <BouquetAct key="bouquet" onNext={next} />;
      case "scratch": return <ScratchAct key="scratch" onNext={next} />;
      case "wall":    return <WallAct key="wall" onNext={next} />;
      case "finale":  return <FinaleAct key="finale" onReplay={replay} />;
      default:        return null;
    }
  };

  return (
    <div className="md-root">
      <Helmet>
        <title>For Mama — Happy Mother's Day</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Petals count={26} />
      {trailEnabled && <HeartTrail />}

      <Link to="/" className="md-back">← back</Link>

      <nav className="md-act-nav" aria-label="acts">
        {ACTS.map((a, i) => (
          <button
            key={a.id}
            className={`md-act-step ${i === actIdx ? "md-current" : ""} ${i < actIdx ? "md-past" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Jump to ${a.label}`}
          >
            <span className="md-act-step-dot" />
            <span className="md-act-step-label">{a.label}</span>
          </button>
        ))}
      </nav>

      <main className="md-main">
        <AnimatePresence mode="wait">{renderAct()}</AnimatePresence>
      </main>
    </div>
  );
};

const MothersDay = () => (
  <GameProvider>
    <Inner />
  </GameProvider>
);

export default MothersDay;
